var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FolderSortRepository } from '../repository/folder-sort-repository.interface';
import { FolderSettingService } from '../types/folder-setting-service.interface';
import { SpaceService } from '../../space/types/space-service.interface';
let FolderSortServiceImpl = class FolderSortServiceImpl {
    constructor(_folderSortRepository, _folderSettingService, _spaceService) {
        this._folderSortRepository = _folderSortRepository;
        this._folderSettingService = _folderSettingService;
        this._spaceService = _spaceService;
    }
    init(params) {
        this._folderSortInitParams = params;
    }
    getSort() {
        return this._folderSortRepository.getFolderSort({
            folderId: this._folderSortInitParams.folderId,
            spaceId: this._folderSortInitParams.spaceId,
            dataType: this._folderSortInitParams.dataType,
        });
    }
    setSort(sort) {
        this._folderSortRepository.setFolderSort({
            folderId: this._folderSortInitParams.folderId,
            spaceId: this._folderSortInitParams.spaceId,
            dataType: this._folderSortInitParams.dataType,
            sort,
        });
    }
    clearSort(spaceId) {
        this._folderSortRepository.clearFolderSort(spaceId || this._folderSortInitParams.spaceId);
        this._spaceService.clearSpaceSetting();
        this._folderSettingService.clearFolderSetting();
    }
};
FolderSortServiceImpl = __decorate([
    injectable(),
    __param(0, inject(FolderSortRepository)),
    __param(1, inject(FolderSettingService)),
    __param(2, inject(SpaceService)),
    __metadata("design:paramtypes", [typeof (_a = typeof FolderSortRepository !== "undefined" && FolderSortRepository) === "function" ? _a : Object, typeof (_b = typeof FolderSettingService !== "undefined" && FolderSettingService) === "function" ? _b : Object, typeof (_c = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _c : Object])
], FolderSortServiceImpl);
export { FolderSortServiceImpl };
